var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-right"},[_c('span',{staticClass:"text-sm"},[_vm._v("Download filtered links as:")]),_c('base-button',{staticClass:"mx-4",attrs:{"theme":"gray"},on:{"click":_vm.csv.download}},[_c('span',{staticClass:"relative text-lg inline-block mr-2"},[_c('base-loading',{staticClass:"absolute",class:{
          'opacity-0': !_vm.csv.downloading.value,
          'opacity-100': _vm.csv.downloading.value,
        }}),_c('icon-download',{class:{
          'opacity-100': !_vm.csv.downloading.value,
          'opacity-0': _vm.csv.downloading.value,
        },attrs:{"title":"Download links in CSV format"}})],1),_vm._v(" CSV ")]),_c('base-button',{attrs:{"theme":"gray"},on:{"click":_vm.excel.download}},[_c('span',{staticClass:"relative text-lg inline-block mr-2"},[_c('base-loading',{staticClass:"absolute",class:{
          'opacity-0': !_vm.excel.downloading.value,
          'opacity-100': _vm.excel.downloading.value,
        }}),_c('icon-download',{class:{
          'opacity-100': !_vm.excel.downloading.value,
          'opacity-0': _vm.excel.downloading.value,
        },attrs:{"title":"Download links in Excel file"}})],1),_vm._v(" Excel ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }